// extracted by mini-css-extract-plugin
export default {"container":"PingMergeAssistant_container__j90PG","header":"PingMergeAssistant_header__3lkrA","text":"PingMergeAssistant_text__u9Gen"};